import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  Input,
  ViewChild,
  ViewContainerRef,
  Type,
  Output,
  EventEmitter
} from '@angular/core';
import { HeaderWidgetComponent } from './header-widget.component';
import { GridHeader } from '../models/gridHeader';
import { GroupType } from '../types/group-type';

@Component({
  selector: 'app-ranking-gridheader-widget-container',
  template: '<template #container></template>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridHeaderContainerComponent implements AfterViewInit {
  @Input() header: GridHeader;
  @Input() widgetComponent: Type<HeaderWidgetComponent>;
  @Input() isLast: boolean;
  @Input() selectedGroup: GroupType;
  @Input() enableSearch: boolean;
  @Output() searchEvent: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('container', { read: ViewContainerRef })
  container: ViewContainerRef;

  constructor(
    private _componentFactoryResolver: ComponentFactoryResolver,
    private _changeDetector: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.container.clear();
    const componentFactory =
      this._componentFactoryResolver.resolveComponentFactory<HeaderWidgetComponent>(
        this.widgetComponent
      );
    const componentRef = this.container.createComponent(componentFactory);
    const instance = componentRef.instance;
    instance.header = this.header;
    instance.isLast = this.isLast;
    instance.selectedGroup = this.selectedGroup;
    instance.enableSearch = this.enableSearch;
    instance.searchEvent.subscribe(value => this.searchEvent.emit(value));
    this._changeDetector.detectChanges();
  }
}
